/*  Copyright © 2009-2025 Autoglot_Lite Team (website : https://autoglot.com)
 *
 *	This program is free software; you can redistribute it and/or modify
 *	it under the terms of the GNU General Public License as published by
 *	the Free Software Foundation; either version 2 of the License, or
 *	(at your option) any later version.
 *
 *	This program is distributed in the hope that it will be useful,
 *	but WITHOUT ANY WARRANTY; without even the implied warranty of
 *	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *	GNU General Public License for more details.
 *
 *	You should have received a copy of the GNU General Public License
 *	along with this program; if not, write to the Free Software
 *	Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA  02110-1301  USA
 */

// List of exposed functions:
//    t_jp.tfl = test_for_lazyrun;
//    t_jp.tfju = test_for_jqueryui;
//    t_jp.at = do_auto_translate;

/*global Date, Math, alert, escape, clearTimeout, document, jQuery, setTimeout, t_jp, window, _mstConfig */
(function ($) { // closure
    var
            // this is the size of strings to queue, we don't want too much there
            BATCH_SIZE = 1024,
            // number of phrases that might be translated
            possibly_translateable,
            // ids of progress bars
            t_jp_prefix = t_jp.prefix,
            // source - 0 is human, 1 google , 2 bing, 3 apertium,
            //          4 yandex, 5 baidu, 6 LibreTranslate - higher reserved for future engines
            ENGINES = {
                'g': {s: 1 }, // Google
                'b': {s: 2 }, // Bing
                'a': {s: 3 }, // Apertium
                'y': {s: 4 }, // Yandex
                'u': {s: 5 }, // Baidu
                'l': {s: 6 }, // LibreTranslate
            }
            ;

    // This function fixes the page, it gets a token and translation and fixes this,
    // since here we only get the automated source, we use this to reduce the code size
    function fix_page(token, translation) {
        // Todo - Probably not needed, but in case we get bad stuff
        if ($.trim(translation).length === 0) {
            return;
        }
        // this is an inner function used to fix the images in the case of being inside the edit mode.
        // if we are not editing, no images will be found and nothing will happen.
        // even if this happens before the edit scripts adds the images, it won't matter as source is changed too and the
        // edit script will fix this
        var fix_image = function () { // handle the image changes
            var img_segment_id = $(this).attr('id').substr($(this).attr('id').lastIndexOf('_') + 1),
                    img = $("#" + t_jp_prefix + "img_" + img_segment_id);
            $("#" + t_jp_prefix + img_segment_id).attr('data-source', 1); // source is 1
            img.removeClass('tr-icon-yellow').removeClass('tr-icon-green').addClass('tr-icon-yellow');
        };

        // might need to escape the token selectors
        //token = token.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
        token = $.escapeSelector(token);
        //window.console && console.log(token);
        // rewrite text for all matching items at once
        $("*[data-orig='" + token + "'][data-hidden!='y']")
                .html(translation)
                .each(fix_image);

        // TODO - FIX hidden elements too (need to update father's title)
        $("*[data-orig='" + token + "'][data-hidden='y']")
                .attr('data-trans', translation)
                .each(fix_image);
    }

    // happens on translate success
    function auto_translate_success(token, translation) {
        // since this moved to the backend, we should not post again
        fix_page(token, translation);
        window.console && console.log(possibly_translateable - $("." + t_jp_prefix + '[data-source=""]').length + "/" + possibly_translateable + " auto translated");
    }

    function mass_translate(engine, batchtrans, lang, success) {
        $.ajax({
            url: t_jp.ajaxurl,
            dataType: "json",
            type: "GET",
            data: {
                action: 'agl_tp',
                e: engine,
                tl: lang,
                q: batchtrans
            },
            success: success
        });
    }

    // Generic invoker
    function invoke_engine(engine, tokens, batchtrans) {
        var cfg = ENGINES[engine];
        if (!cfg) return;
        source = cfg.s;
        mass_translate(engine, batchtrans, t_jp.lang, function (result) {
            var arr;
            try {
                arr = result.results;
            } catch (e) {
                arr = [];
            }
            for (var i = 0; i < arr.length && i < tokens.length; i++) {
                auto_translate_success(tokens[i], arr[i]);
            }
        });
    }

    // Unified dispatcher
    function do_mass_invoke(batchtokens, batchtrans) {
        if (!batchtokens.length) return;
        t_jp.preferred.some(function (engine) {
            if (t_jp.engines[engine]) {
                invoke_engine(engine, batchtokens, batchtrans);
                return true;
            }
        });
    }

    //function for auto translation
    function do_auto_translate() {
        // auto_translated_previously...
        var auto_translated_phrases = [], batchlength = 0, batchtrans = [], batchtokens = [];

        $("." + t_jp_prefix + '[data-source=""]').each(function () {
            var token = $(this).attr('data-orig'),
            // we only have orig if we have some translation? so it should probably not be here... ? (or maybe for future invalidations of cached auto translations)
                to_trans = $(this).attr('data-orig');
            // should not happen, but just in case
            if (!token || token.length === 0) {
                return; // continue
            }
            if (to_trans === undefined) {
                to_trans = $(this).html();
            }
            if (auto_translated_phrases[to_trans] !== 1) {
                auto_translated_phrases[to_trans] = 1;
                if (batchlength + encodeURIComponent(to_trans).length > BATCH_SIZE) {
                    do_mass_invoke(batchtokens, batchtrans);
                    batchlength = 0;
                    batchtrans = [];
                    batchtokens = [];
                }
                batchlength += encodeURIComponent(to_trans).length;
                batchtokens.push(token);
                batchtrans.push(to_trans);
            }
        });
        // this invokation is for the remaining items
        do_mass_invoke(batchtokens, batchtrans);
    }

    // helper function for lazy running
    function test_for_lazyrun(callback) {
        if (typeof $.xLazyLoader === 'function') {
            callback();
        } else {
            t_jp.$ = $; // We wanted the same jQuery... hmmm
            $.getScript(t_jp.plugin_url + '/js/lazy.js', callback).done(callback);
        }
    }

    function test_for_jqueryui(callback) {
        if (test_for_jqueryui.hit /* might be needed? - && typeof $.fn.dialog !== 'function' */) {
            callback();
        } else {
            test_for_jqueryui.hit = true;
            test_for_lazyrun(function () {
                // This is needed when old jQueryUI is being loaded (default for wp3.2)
                $.fn.propAttr = $.fn.prop || $.fn.attr;
                $.xLazyLoader({
                    js: t_jp.jQueryUI + 'jquery-ui.min.js',
                    css: t_jp.jQueryUI + 'themes/' + t_jp.theme + '/jquery-ui.css',
                    success: callback
                });
            });
        }
    }

    // expose some functions
    t_jp.at = do_auto_translate;
    t_jp.tfl = test_for_lazyrun;
    t_jp.tfju = test_for_jqueryui;

    $(function () {

        // this is the set_default_language function
        // attach a function to the set_default_language link if its there
        $('.' + t_jp_prefix + 'setdeflang').on("click", function () {
            $.ajax({
                url: t_jp.ajaxurl,
                data: {
                    action: 'agl_cookie'
                },
                cache: false
            });
            $('.' + t_jp_prefix + 'setdeflang').hide("slow");
            return false;
        });

        // how many phrases are yet untranslated
        possibly_translateable = $("." + t_jp_prefix + '[data-source=""]').length;

        //now = new Date();
        // we make sure script sub loaded are cached
        $.ajaxSetup({
            cache: true
        });
        // was: we'll only auto-translate and load the stuff if we either have more than 5 candidate translations, or more than one at 4am, and this language is supported...
        // we'll translate if there's any candidate...?
        if (possibly_translateable && !t_jp.noauto && !$.isEmptyObject(t_jp.engines)) {
            do_auto_translate();
        }

        // this is the part when we have editor support
        if (t_jp.edit) {
            $.getScript(t_jp.plugin_url + '/js/autoglot_liteedit.js');
        }
    });
}(jQuery)); // end of closure